import { ReactElement } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';
import { observer } from 'mobx-react-lite';

interface CConfirmModalProps {
  isOpen: boolean;
  title: string;
  content?: ReactElement;
  confirmText: string;
  onConfirm: () => void;
  cancelText: string;
  onCancel: () => void;
}

export const CConfirmModal = observer(
  ({
    isOpen,
    title,
    content,
    confirmText,
    onConfirm,
    cancelText,
    onCancel,
  }: CConfirmModalProps) => {
    return (
      <StyledDialog fullWidth open={isOpen} onClose={onCancel}>
        <StyledDialogTitle>{title}</StyledDialogTitle>
        {content && <StyledDialogContent>{content}</StyledDialogContent>}
        <DialogActions>
          <StyledCancelButton variant="contained" onClick={onCancel}>
            {cancelText}
          </StyledCancelButton>
          <StyledConfirmButton variant="contained" onClick={onConfirm}>
            {confirmText}
          </StyledConfirmButton>
        </DialogActions>
      </StyledDialog>
    );
  },
);

export default CConfirmModal;

const StyledDialog = styled(Dialog)(() => ({
  '.MuiPaper-root': {
    borderRadius: '16px',
  },
}));

const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontWeight: 600,
  fontSize: '24px',
  lineHeight: '150%',
  textAlign: 'center',
}));

const StyledDialogContent = styled(DialogContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}));

const StyledCancelButton = styled(Button)(({ theme }) => ({
  width: '50%',
  height: '52px',
  fontSize: '16px',
  lineHeight: '150%',
  borderRadius: '8px',
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.grey[600],
}));

const StyledConfirmButton = styled(Button)(() => ({
  width: '50%',
  height: '52px',
  fontSize: '16px',
  lineHeight: '150%',
  borderRadius: '8px',
}));
